export const partMenuList = [
  {
    key: 'rotate-part',
    type: 'rotate',
    icon: 'icon-recover',
    label: '旋转板件',
    isShow: true,
    id: 1,
    parentId: null,
    children: [
      {
        key: 'rotate-part-90',
        type: 'rotate-90',
        icon: '',
        label: '旋转90度',
        isShow: true,
        id: 101,
        parentId: 1,
        children: [],
      },
      {
        key: 'rotate-part-180',
        type: 'rotate-180',
        icon: '',
        label: '旋转180度',
        isShow: true,
        id: 102,
        parentId: 1,
        children: [],
      },
      {
        key: 'rotate-part-270',
        type: 'rotate-270',
        icon: '',
        label: '旋转270度',
        isShow: true,
        id: 103,
        parentId: 1,
        children: [],
      },
    ],
  },
  {
    key: 'flip-part',
    type: 'flip',
    icon: 'icon-yuliao',
    label: '板件翻面',
    isShow: true,
    id: 2,
    parentId: null,
    children: [],
  },
  {
    key: 'addBujian-part',
    type: 'addBujian',
    icon: 'icon-yuliao',
    label: '添加补件',
    isShow: true,
    id: 3,
    parentId: null,
    children: [],
  },
  {
    key: 'deletePart-part',
    type: 'deletePart',
    icon: 'icon-yuliao',
    label: '删除板件',
    isShow: true,
    id: 4,
    parentId: null,
    children: [],
  },
  // {
  //   key: 'changePriority-part',
  //   type: 'changePriority',
  //   icon: 'icon-yuliao',
  //   label: '修改切割顺序',
  //   isShow: true,
  //   id: 5,
  //   children: [
  //     {
  //       key: 'first-part',
  //       type: 'first',
  //       icon: 'icon-yuliao',
  //       label: '最先切',
  //       isShow: true,
  //       parentId: 5,
  //       id: 51,
  //     },
  //     {
  //       key: 'last-part',
  //       type: 'last',
  //       icon: 'icon-yuliao',
  //       label: '最后切',
  //       isShow: true,
  //       parentId: 5,
  //       id: 52,
  //     },
  //     {
  //       key: 'prev-part',
  //       type: 'prev',
  //       icon: 'icon-yuliao',
  //       label: '提前一个切',
  //       isShow: true,
  //       parentId: 5,
  //       id: 53,
  //     },
  //     {
  //       key: 'next-part',
  //       type: 'next',
  //       icon: 'icon-yuliao',
  //       label: '往后一个切',
  //       isShow: true,
  //       parentId: 5,
  //       id: 54,
  //     },
  //   ],
  // },
  {
    key: 'feedback-part',
    type: 'feedback',
    icon: 'icon-yuliao',
    label: '排版反馈',
    isShow: true,
    id: 6,
    parentId: null,
    children: [
      {
        key: 'runningBoard-part',
        type: 'runningBoard',
        icon: 'icon-yuliao',
        label: '切割跑板',
        isShow: true,
        parentId: 6,
        id: 61,
      },
      {
        key: 'lowUtilizationRate-part',
        type: 'lowUtilizationRate',
        icon: 'icon-yuliao',
        label: '利用率低',
        isShow: true,
        parentId: 6,
        id: 62,
      },
      {
        key: 'unreasonableLayout-part',
        type: 'unreasonableLayout',
        icon: 'icon-yuliao',
        label: '排版不合理',
        isShow: true,
        parentId: 6,
        id: 63,
      },
    ],
  },
] as const
export const bigPlankMenuList = [
  {
    key: 'useSurplus-bigPlank',
    label: '使用余料',
    type: 'useSurplus',
    icon: 'icon-yuliao',
    isShow: true,
    id: 7,
    parentId: null,
    children: [],
  },
  {
    key: 'subTle-bigPlank',
    label: '精细排版',
    type: 'subTle',
    icon: 'icon-check',
    isShow: true,
    id: 8,
    parentId: null,
    children: [],
  },
  {
    key: 'addPlank-bigPlank',
    label: '添加大板',
    type: 'addPlank',
    icon: 'icon-add',
    isShow: true,
    id: 9,
    parentId: null,
    children: [],
  },
  {
    key: 'deletePlank-bigPlank',
    label: '删除大板',
    type: 'deletePlank',
    icon: 'icon-delete',
    isShow: true,
    id: 10,
    parentId: null,
    children: [],
  },
  {
    key: 'feedback-bigPlank',
    type: 'feedback',
    icon: 'icon-yuliao',
    label: '排版反馈',
    isShow: true,
    id: 6,
    parentId: null,
    children: [
      {
        key: 'runningBoard-bigPlank',
        type: 'runningBoard',
        icon: 'icon-yuliao',
        label: '切割跑板',
        isShow: true,
        parentId: 6,
        id: 61,
      },
      {
        key: 'lowUtilizationRate-bigPlank',
        type: 'lowUtilizationRate',
        icon: 'icon-yuliao',
        label: '利用率低',
        isShow: true,
        parentId: 6,
        id: 62,
      },
      {
        key: 'unreasonableLayout-bigPlank',
        type: 'unreasonableLayout',
        icon: 'icon-yuliao',
        label: '排版不合理',
        isShow: true,
        parentId: 6,
        id: 63,
      },
    ],
  },
] as const

export const otherMenuList = [
  {
    key: 'feedback-other',
    type: 'feedback',
    icon: 'icon-yuliao',
    label: '排版反馈',
    isShow: true,
    children: [
      {
        key: 'runningBoard-other',
        type: 'runningBoard',
        icon: 'icon-yuliao',
        label: '切割跑板',
        isShow: true,
      },
      {
        key: 'lowUtilizationRate-other',
        type: 'lowUtilizationRate',
        icon: 'icon-yuliao',
        label: '利用率低',
        isShow: true,
      },
      {
        key: 'unreasonableLayout-other',
        type: 'unreasonableLayout',
        icon: 'icon-yuliao',
        label: '排版不合理',
        isShow: true,
      },
    ],
  },
] as const
